import AbsComponent from '../../common/components/AbsComponent';
import EffectInfoTempl from './EffectInfoTempl';

/**
 * Sub1 class
 * @category testApp
 */
class EffectInfo extends AbsComponent{
    constructor(_store={}, _el=''){
        super(_store, _el);
        this.store.getCharacterEffectData(_store.data.config.serverType, _store.data.config.serverId, _store.data.config.characterName, this.render.bind(this));
    }

    render(_jsonData = {}){
        $(this.el).find('.character-effect-inner').append(EffectInfoTempl.getTempl(_jsonData));
        $(this.el).append(EffectInfoTempl.getSetTempl(_jsonData));
    }
}

export default EffectInfo;
